export const getAPI = (): string => {
  return sessionStorage.getItem('OVERRIDE_API') ?? (process.env.REACT_APP_BASE_URL as string)
}

export const getStationId = (): string => {
  return sessionStorage.getItem('OVERRIDE_STATION_ID') ?? (process.env.REACT_APP_STATION_ID as string)
}
